import React from "react";
import AutoLayout from "../AutoLayout/AutoLayout";
import {
  AutoLayoutAlignEnum,
  AutoLayoutDirectionEnum,
  AutoLayoutResizingEnum,
} from "../AutoLayout/AutoLayoutEnums";
import FontText from "../../FontText/FontText";
import { FontSizeEnum, FontTypeEnum } from "../../FontText/FontTextEnums";
import { ThemeIconEnum } from "../../Themes/ThemeEnums";
import IconButton from "../../Button/IconButton/IconButton";
import ErrorState from "../../ErrorState/ErrorState";

export interface BackHeaderPageError {
  headline: string;
  supporting?: string;
  retry: { label: string; onClick: () => void };
}

interface BackHeaderPageProps {
  title: string;
  backLabel: string;
  onBack: () => void;
  isLoading?: boolean;
  error?: BackHeaderPageError;
  loadingSkeleton?: React.ReactNode;
  children: React.ReactNode;
}

const BackHeaderPage: React.FC<BackHeaderPageProps> = ({
  title,
  backLabel,
  onBack,
  isLoading,
  error,
  loadingSkeleton,
  children,
}) => (
  <>
    <AutoLayout
      $direction={AutoLayoutDirectionEnum.HORIZONTAL}
      $align={AutoLayoutAlignEnum.LEFT}
      $horizontalResizing={AutoLayoutResizingEnum.FILL}
      $gap={8}
    >
      <IconButton icon={ThemeIconEnum.ARROW_BACK} ariaLabel={backLabel} onClick={onBack} />
      <FontText text={title} $fontSize={FontSizeEnum.LARGE} $fontType={FontTypeEnum.TITLE} />
    </AutoLayout>
    {isLoading ? (
      loadingSkeleton
    ) : error ? (
      <ErrorState headline={error.headline} supporting={error.supporting} retry={error.retry} />
    ) : (
      children
    )}
  </>
);

export default BackHeaderPage;
